import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 22758 27975"
    {...props}
  >
    <path
      d="M0 16331V3320C0 2212 252 1386 750 832 1248 277 1903 0 2716 0c844 0 1518 277 2016 832 498 554 750 1386 750 2488v13313c0 1513 170 2779 510 3793 334 1015 939 1802 1796 2363 863 561 2066 838 3616 838 2142 0 3655-567 4543-1707 888-1141 1329-2867 1329-5179V3320c0-1115 246-1953 737-2501 492-548 1153-819 1979-819 819 0 1487 271 1997 819s769 1386 769 2501v13011c0 2117-208 3888-618 5299-416 1417-1191 2658-2337 3730-983 907-2130 1568-3434 1990-1304 416-2829 625-4574 625-2080 0-3869-228-5374-675-1500-447-2723-1146-3668-2085-951-939-1644-2149-2091-3617C221 20130 0 18372 0 16331z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
